import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { canAccessRoute, homeForRole } from '../utils/access';

/**
 * ProtectedRoute Component
 * Redirects to login page if user is not authenticated
 * Shows loading spinner while checking authentication
 * 
 * Usage:
 * <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, authData } = useContext(AuthContext);

  // Wait for auth to be ready - show loading spinner
  if (!authData.ready) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  if (!canAccessRoute(authData.userTypeId, allowedRoles)) {
    return <Navigate to={homeForRole(authData.userTypeId)} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
